var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "mobile-page", style: _vm.boxStyle }, [
        _c("div", { staticClass: "banner-two" }, [
          _c("div", { staticClass: "img-box" }, [
            _vm.swiperType == 0
              ? _c("div", { staticClass: "img-item itemLeft" }, [
                  _vm.imgSrcList.length > 1 && _vm.imgSrcList[1].img
                    ? _c("img", {
                        staticClass: "img-left",
                        style: _vm.contentStyleLeft,
                        attrs: {
                          src:
                            _vm.imgSrcList.length > 1 && _vm.imgSrcList[1].img,
                          alt: "",
                        },
                      })
                    : _c("div", {
                        staticClass: "empty-box empty-left",
                        style: _vm.contentStyleLeft,
                      }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "img-item item-middle" }, [
              _vm.imgSrcList.length && _vm.imgSrcList[0].img
                ? _c("img", {
                    staticClass: "img-middle",
                    style: _vm.contentStyleMiddle,
                    attrs: {
                      src: _vm.imgSrcList.length && _vm.imgSrcList[0].img,
                      alt: "",
                    },
                  })
                : _c(
                    "div",
                    {
                      staticClass: "empty-box empty-middle",
                      style: _vm.contentStyleMiddle,
                    },
                    [
                      _c("span", {
                        staticClass: "iconfont iconfont icontupian",
                      }),
                    ]
                  ),
              _vm._v(" "),
              _c("div", [
                _vm.docType === 0
                  ? _c(
                      "div",
                      { staticClass: "dot more-dot", style: _vm.dotStyle },
                      [
                        _c("div", {
                          staticClass: "dot-item",
                          style: {
                            background: _vm.themeStyle
                              ? _vm.configObj.docColor.color[0].item
                              : _vm.mobileTheme,
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "dot-item" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "dot-item" }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.docType === 1
                  ? _c(
                      "div",
                      {
                        staticClass: "dot more-dot line-dot",
                        style: _vm.dotStyle,
                      },
                      [
                        _c("div", {
                          staticClass: "line_dot-item",
                          style: {
                            background: _vm.themeStyle
                              ? _vm.configObj.docColor.color[0].item
                              : _vm.mobileTheme,
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "line_dot-item" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "line_dot-item" }),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.swiperType == 0
              ? _c("div", { staticClass: "img-item item-right" }, [
                  _vm.imgSrcList.length > 2 && _vm.imgSrcList[2].img
                    ? _c("img", {
                        staticClass: "img-right",
                        style: _vm.contentStyleRight,
                        attrs: {
                          src:
                            _vm.imgSrcList.length > 2 && _vm.imgSrcList[2].img,
                          alt: "",
                        },
                      })
                    : _c("div", {
                        staticClass: "empty-box empty-right",
                        style: _vm.contentStyleRight,
                      }),
                ])
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }